import React, { useState } from "react";
import { codeToFlagEmoji, getCountryName } from "../data/countries";

// Renders a small country flag. Uses flagcdn's SVG so it looks like a real flag
// on every platform — including Windows, where emoji flags render as plain
// letters. If the image can't load (e.g. offline), it degrades to the emoji
// flag, and finally to the bare country code.
export default function CountryFlag({ code, size = 18, title, style }) {
  const [imgFailed, setImgFailed] = useState(false);
  const cc = String(code || "").toUpperCase();
  if (cc.length !== 2) return null;

  const label = title || getCountryName(cc) || cc;

  if (imgFailed) {
    const emoji = codeToFlagEmoji(cc);
    return (
      <span
        role="img"
        aria-label={label}
        title={label}
        style={{ fontSize: size, lineHeight: 1, ...style }}
      >
        {emoji || cc}
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/${cc.toLowerCase()}.svg`}
      alt={label}
      title={label}
      width={size}
      onError={() => setImgFailed(true)}
      style={{
        height: "auto",
        borderRadius: 2,
        display: "block",
        boxShadow: "0 0 0 1px rgba(0,0,0,0.15)",
        ...style,
      }}
    />
  );
}
